import "./styles.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <Weather defaultCity="Barcelona" />
      <footer>
        {" "}
        <a
          href="https://github.com/Andrerodriguezd/weather-react?tab=repositories"
          target="-blank"
          rel="noreferrer"
        >
          Open-source code
        </a>{" "}
        by, Andrea Rodríguez{" "}
      </footer>
    </div>
  );
}
